"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Tss(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M15.113 15.556a3.226 3.226 0 0 1 3.223 3.222A3.226 3.226 0 0 1 15.113 22a3.226 3.226 0 0 1-3.222-3.222 3.226 3.226 0 0 1 3.222-3.222zm0 2a1.223 1.223 0 0 0 0 2.444c.674 0 1.223-.548 1.223-1.222 0-.674-.549-1.222-1.223-1.222zM13.36 2a6.207 6.207 0 0 1 6.201 6.2 6.208 6.208 0 0 1-6.621 6.187A5.018 5.018 0 0 1 8 18.56c-2.757 0-5-2.247-5-5.01a5.009 5.009 0 0 1 4.174-4.932A6.207 6.207 0 0 1 13.36 2zm0 2a4.205 4.205 0 0 0-4.2 4.2c0 .393.05.756.148 1.08l.431 1.43-1.485-.144A2.564 2.564 0 0 0 8 10.55c-1.654 0-3 1.346-3 3a3.009 3.009 0 0 0 3 3.01 3.015 3.015 0 0 0 3.011-3.01c0-.056.004-.106-.004-.158l-.25-1.575 1.522.436c.325.098.689.148 1.081.148A4.205 4.205 0 0 0 17.561 8.2c0-2.316-1.884-4.2-4.201-4.2z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Tss;
